import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/providers/clinical-protocol-acog-smfm/#webpage",
   "url": "https://www.futurefamilyai.com/providers/clinical-protocol-acog-smfm/",
   "name": "ACOG/SMFM-Based Monitoring Protocol | FutureFamilyAI",
   "description": "How FutureFamilyAI's protocol is informed by ACOG, SMFM, ISSHP and AHA guidance, with human review at Orange and Red and clinician-set thresholds.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "EMR Integration",
     "item": "https://www.futurefamilyai.com/providers/emr-integration/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Clinical Protocol",
     "item": "https://www.futurefamilyai.com/providers/clinical-protocol-acog-smfm/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Which guidelines inform the protocol?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "ACOG, SMFM, ISSHP and AHA guidance."
     }
    },
    {
     "@type": "Question",
     "name": "Who wrote the protocol?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Dr. Kulsoom Baloch, MBBS, MPH, with medical review by Dr. Rashmi Gulati, MD."
     }
    },
    {
     "@type": "Question",
     "name": "Are thresholds published?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Specific thresholds are shared with partner clinicians after protocol review and approval."
     }
    },
    {
     "@type": "Question",
     "name": "Does an algorithm decide escalation?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Orange and Red are reviewed by people."
     }
    },
    {
     "@type": "Question",
     "name": "How often is the protocol updated?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "At least annually and whenever key guidance changes."
     }
    },
    {
     "@type": "Question",
     "name": "Can practices request changes?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Practice-specific thresholds follow the treating clinician within the protocol framework."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function ProvidersClinicalProtocolAcogSmfmPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/providers/emr-integration">EMR Integration</Link>
              <span>›</span>
              <span>Clinical Protocol</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                FutureFamilyAI&apos;s monitoring protocol, authored by Dr.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Physicians &amp; OB providers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      In pregnancy, a blood pressure of 160 systolic or 110
                      diastolic or higher is in the severe range and needs
                      urgent evaluation. (ACOG Practice Bulletin No. 222, 2020)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Guideline-informed · Human-in-the-loop by design ·
                      Clinician-set thresholds
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">PROVIDER GUIDE</span>
            <h1>ACOG/SMFM-Based Pregnancy Monitoring Protocol</h1>
            <p className="ffh-answer speakable-content">
              FutureFamilyAI&apos;s monitoring protocol, authored by Dr. Kulsoom
              Baloch, MBBS, MPH, is informed by ACOG, SMFM, ISSHP and AHA
              guidance. Validated-cuff readings are the only blood pressure
              source, members see color statuses rather than scores, and Orange
              and Red patterns trigger human review following the treating
              clinician&apos;s thresholds. Specific alert thresholds are
              published to partner clinicians after protocol review. Request the
              protocol summary.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Clinicians reviewing FutureFamilyAI's guideline-based monitoring protocol"
              >
                <figcaption>
                  <b>Photo slot</b> · Two clinicians reviewing a printed
                  protocol document together at a table (text unreadable),
                  focused and collaborative.
                  <br />
                  <b>Alt:</b> Clinicians reviewing FutureFamilyAI&apos;s
                  guideline-based monitoring protocol
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    In pregnancy, a blood pressure of 160 systolic or 110
                    diastolic or higher is in the severe range and needs urgent
                    evaluation.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/practice-bulletin/articles/2020/06/gestational-hypertension-and-preeclampsia">
                        ACOG Practice Bulletin No. 222, 2020
                      </a>
                    </cite>
                  </li>
                  <li>
                    ACOG recommends a blood pressure check no later than 7–10
                    days after delivery for people with hypertensive disorders
                    of pregnancy, and within 72 hours for severe hypertension.
                    <cite>
                      Source:{" "}
                      <a href="https://www.acog.org/clinical/clinical-guidance/committee-opinion/articles/2018/05/optimizing-postpartum-care">
                        ACOG Committee Opinion No. 736, 2018
                      </a>
                    </cite>
                  </li>
                  <li>
                    The USPSTF recommends screening for hypertensive disorders
                    of pregnancy with blood pressure measurements throughout
                    pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/hypertensive-disorders-pregnancy-screening">
                        USPSTF, 2023
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Protocol principles</h2>
                <ul>
                  <li>Cuff is the only authoritative blood pressure source</li>
                  <li>Color status for members; no numeric risk score</li>
                  <li>Human review at Orange and Red</li>
                  <li>Not real-time; emergency instructions always shown</li>
                  <li>
                    PRV shown as a wellness trend, not a diagnostic measure
                  </li>
                </ul>
              </section>
              <section id="s2">
                <h2>Governance</h2>
                <p>
                  The protocol is reviewed by Dr. Rashmi Gulati, MD, and updated
                  when relevant guidance changes.
                </p>
              </section>
              <div className="ffh-inline-cta">
                <p>No partner fees. Our care team handles patient setup.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=physician"
                >
                  Request a Clinical Demo
                </Link>
              </div>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>Which guidelines inform the protocol?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>ACOG, SMFM, ISSHP and AHA guidance.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Who wrote the protocol?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Dr. Kulsoom Baloch, MBBS, MPH, with medical review by
                        Dr. Rashmi Gulati, MD.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Are thresholds published?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Specific thresholds are shared with partner clinicians
                        after protocol review and approval.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Does an algorithm decide escalation?</summary>
                    <div className="ffh-ans">
                      <p>No. Orange and Red are reviewed by people.</p>
                    </div>
                  </details>
                  <details>
                    <summary>How often is the protocol updated?</summary>
                    <div className="ffh-ans">
                      <p>
                        At least annually and whenever key guidance changes.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can practices request changes?</summary>
                    <div className="ffh-ans">
                      <p>
                        Practice-specific thresholds follow the treating
                        clinician within the protocol framework.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">RG</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Rashmi Gulati, MD</h3>
                  <p>
                    Medical Director, Patients Medical. Dr. Rashmi Gulati, MD,
                    is Medical Director of Patients Medical, a Manhattan
                    practice founded in 1974. She leads FutureFamilyAI&apos;s
                    physician and care-team content and medically reviews every
                    page on this site.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/providers/emr-integration">EMR Integration →</Link>
                  <Link to="/providers">For Physicians →</Link>
                  <Link to="/providers/epic-integration-patient-generated-data">
                    Epic Patient-Generated Data →
                  </Link>
                  <Link to="/providers/physician-dashboard-pregnancy-monitoring">
                    Physician Dashboard →
                  </Link>
                  <Link to="/providers/how-to-recommend-future-family">
                    Recommend FutureFamilyAI →
                  </Link>
                  <Link to="/providers/emr-systems-supported">
                    Supported EMR Systems →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.patientsmedical.com">
                    https://www.patientsmedical.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">Protocol principles</a>
                  </li>
                  <li>
                    <a href="#s2">Governance</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=physician"
                >
                  Request a Clinical Demo
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
